import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { initHooks } from "./hooks";
function initRuntimeContext() {
  return {};
}
function createRuntimeContext(param) {
  var runtimeContext = param.runtimeContext, config = param.config, plugins = param.plugins;
  var extendsHooks = {};
  plugins.forEach(function(plugin) {
    var _plugin_registryHooks = plugin.registryHooks, registryHooks = _plugin_registryHooks === void 0 ? {} : _plugin_registryHooks;
    Object.keys(registryHooks).forEach(function(hookName) {
      extendsHooks[hookName] = registryHooks[hookName];
    });
  });
  return _object_spread_props(_object_spread({}, runtimeContext), {
    hooks: _object_spread({}, initHooks(), extendsHooks),
    extendsHooks,
    config
  });
}
export {
  createRuntimeContext,
  initRuntimeContext
};
